import {getSystematicByCodes} from "@/network/systematic";
import {platenComponents} from "@/assets/js/components/platen";
import {initializeCustomPage} from "@/network/device-custom-page";

//初始化大屏
export function initPlaten() {
  let code = "screen_template";
  let codes = ['big_screen_abbreviation', 'big_screen_title', 'screen_template'];

  getSystematicByCodes(codes).then(res => {
    if (res.code === 0) {
      let abbreviation = ""
      let title = ""
      let template = {}
      res.data.forEach(item => {
        if (item.code === "big_screen_abbreviation") {
          abbreviation = item.val1;
        }
        if (item.code === "big_screen_title") {
          title = item.val1;
        }
        if (item.code === "screen_template") {
          template = item;
        }
      })
      if (!template.id) {
        let deviceCustomLayout = []
        platenComponents.forEach(item => {
          const layout = {
            name: item.name,
            component: item.componentsName,
            params: JSON.stringify(item.position)
          }
          deviceCustomLayout.push(layout)
        })
        let deviceCustomPage = {
          page: '/platen/index',
          title: title,
          name: '初始模板',
          abbreviation: abbreviation,
          bgImage: '/static/images/big_screen/index5.png'
        };
        let deviceCustomPageDto = {
          deviceCustomPage: deviceCustomPage,
          deviceCustomLayouts: deviceCustomLayout,
          startUsing: true,
          code: code
        };
        initializeCustomPage(deviceCustomPageDto).then(res => {
          console.log(res);
        })
      }
    }
  })
}
